<template>
  <div class="cwImageWrapper" v-if="isVisible">
    <img :src="cmpConfig.data.url" alt="" />
  </div>
</template>

<script>
import expertviewMixin from './experviewMixin';

export default {
  name: 'CwImageWrapper',
  mixins: [expertviewMixin],
  props: {
    cmpConfig: {
      type: Object,
      default: () => {}
    }
  },
  created() {
    this.$log.debug('cwImageWrapper::created()', this.cmpConfig);

    if (this.ruleSubscriber.length > 0) {
      this.applyRules();
    }
  }
};
</script>

<style scoped lang="scss">
.cwImageWrapper {
  img {
    object-fit: cover;
    width: 100%;
    max-height: 100%;
  }
}
</style>
